import axios from 'axios';
import { ceil } from 'lodash';

// import * as artistApi from '@/api/artist/artist';
import * as salesApi from '@/api/artist/sales.js';
import programsApi from '@/api/artist/programs';

// import {
//   salesEventsMockData,
//   salesEarningsMockData,
// } from '@/views/artist/sales/mock/salesData.js';

function refreshCancelToken(state, tokenName) {
  // cancel previous request
  if (_.has(state.cancelTokens, tokenName)) {
    const info = {
      type: 'cancelToken',
      name: `${tokenName}`,
    };
    state.cancelTokens[tokenName].cancel(info);
  }

  // create cancel token
  state.cancelTokens[tokenName] = axios.CancelToken.source();

  return state.cancelTokens[tokenName];
}

const state = {
  // data
  events: [],
  eventsLoading: false,
  earnings: [],
  earningsLoading: false,
  elementsStats: [],
  // compare data
  eventsLastYear: [],
  earningsLastYear: [],
  // report type & status
  gcpProgram: null,
  reportType: 'all',
  interval: 'month',
  // date status keep number
  startMonth: null,
  startYear: null,
  endMonth: null,
  endYear: null,
  // period keep string
  periodStart: null,
  periodEnd: null,
  periodStartLastYear: '2019-01',
  periodEndLastYear: '2019-01',
  // mock toggle
  mock: 'false', // query string
  //
  cancelTokens: {},
  recentDownloads: [],
  salesEvents: [],
  salesKeywords: [],
  salesProducts: [],
  funnelData: [],
};

const getters = {
  // data
  earnings: ({ earnings }) => earnings,
  events: ({ events }) => events,
  earningsLastYear: ({ earningsLastYear }) => earningsLastYear,
  eventsLastYear: ({ eventsLastYear }) => eventsLastYear,
  // option
  gcpProgram: ({ gcpProgram }) => gcpProgram,
  reportType: ({ reportType }) => reportType,
  interval: ({ interval }) => interval,
  // date control
  startMonth: ({ startMonth }) => startMonth,
  startYear: ({ startYear }) => startYear,
  endMonth: ({ endMonth }) => endMonth,
  endYear: ({ endYear }) => endYear,
  // periodStart: ({ periodStart }) => periodStart,
  periodStart(state) {
    return state.startMonth && state.startYear
      ? `${state.startYear}-${String(state.startMonth).padStart(2, '0')}` : null;
  },
  // periodEnd: ({ periodEnd }) => periodEnd,
  periodEnd(state) {
    return state.endMonth && state.endYear
      ? `${state.endYear}-${String(state.endMonth).padStart(2, '0')}` : null;
  },
  periodStartLastYear: ({ periodStartLastYear }) => periodStartLastYear,
  periodEndLastYear: ({ periodEndLastYear }) => periodEndLastYear,
  // computed datas
  // showGcpSubOptoutData: (state) => {
  //   if (has(state.account, 'artistDetails.programs.gcp_subscription.ended_at')) {
  //     return `${this.$t('sales.opted_out')}: ${format(new Date(state.account.artistDetails.programs.gcp_subscription.ended_at * 1000), 'yyyy-MM-dd')}`;
  //   }
  //   return false;
  // },
  // showGcpApiOptoutData: (state) => {
  //   if (has(state.account, 'artistDetails.programs.gcp_api_edit.ended_at')) {
  //     return `${this.$t('sales.opted_out')}: ${format(new Date(state.account.artistDetails.programs.gcp_api_edit.ended_at * 1000), 'yyyy-MM-dd')}`;
  //   }
  //   return false;
  // },
  filterTotal: (state) => {
    if (state.earnings.length) {
      const totalArr = state.earnings.filter(x => x.type === 'total');
      return totalArr;
    }
    return [];
  },
  filterOnDemand: (state) => {
    if (state.earnings.length) {
      const onDemandArr = state.earnings.filter(x => x.type === 'on_demand');
      return onDemandArr;
    }
    return [];
  },
  getEarningsByType: (state) => (type) => (state.earnings.length ? state.earnings.filter(x => x.type === type) : []),
  filterGcp: (state) => {
    if (state.earnings.length) {
      return state.earnings.filter(x => x.type === 'gcp_subscription');
    }
    return [];
  },
  filterGcpApi: (state) => {
    if (state.earnings.length) {
      return state.earnings.filter(x => x.type === 'gcp_api_edit');
    }
    return [];
  },
  filterImgSubscription: (state) => {
    if (state.earnings.length) {
      return state.earnings.filter(x => x.type === 'image_subscription');
    }
    return [];
  },
  filterViewed: (state) => {
    if (state.events.length) {
      return state.events.filter(x => x.event === 'product_viewed');
    }
    return [];
  },
  filterSearched: (state) => {
    if (state.events.length) {
      return state.events.filter(x => x.event === 'product_searched');
    }
    return [];
  },
  // "product_favorited"
  filterFavorited: (state) => {
    if (state.events.length) {
      return state.events.filter(x => x.event === 'product_favorited');
    }
    return [];
  },
  filterOrderCompleted: (state) => {
    if (state.events.length) {
      return state.events.filter(x => x.event === 'product_downloaded');
    }
    return [];
  },
  filterRefunded: (state) => {
    if (state.events.length) {
      const totalArr = state.events.filter(x => x.event === 'product_refunded');
      return totalArr;
    }
    return [];
  },
  filterPurchased: (state) => {
    if (state.events.length) {
      const totalArr = state.events.filter(x => x.event === 'product_purchased');
      return totalArr;
    }
    return [];
  },
  countLastYear: (state) => {
    // get last year data
    const viewedArr = [];
    const favoritedArr = [];
    const downloadedArr = [];
    const purchasedArr = [];
    const totalArr = [];
    const onDemandArr = [];
    const gcpSubArr = [];
    const gcpApiArr = [];
    const imgSub = [];

    if (state.eventsLastYear.length) {
      viewedArr.push(...state.eventsLastYear.filter(x => x.event === 'product_viewed'));
      favoritedArr.push(...state.eventsLastYear.filter(x => x.event === 'product_favorited'));
      downloadedArr.push(...state.eventsLastYear.filter(x => x.event === 'product_downloaded'));
      // refundedArr.push(...state.eventsLastYear.filter(x => x.event === 'product_refunded'));
      purchasedArr.push(...state.eventsLastYear.filter(x => x.event === 'product_purchased'));
    }
    if (state.earningsLastYear.length) {
      totalArr.push(...state.earningsLastYear.filter(x => x.type === 'total'));
      onDemandArr.push(...state.earningsLastYear.filter(x => x.type === 'on_demand'));
      // gcpSubArr.push(...state.earningsLastYear.filter(x => x.type === 'gcp_subscription'));
      gcpSubArr.push(...state.earningsLastYear.filter(x => x.type === 'gcp_subscription'));
      gcpApiArr.push(...state.earningsLastYear.filter(x => x.type === 'gcp_api_edit'));
      imgSub.push(...state.earningsLastYear.filter(x => x.type === 'image_subscription'));
    }
    // count last year data
    let countLastViewed = 0;
    let countLastFavorited = 0;
    let countLastDownloaded = 0;
    let countLastPurchased = 0;
    let countLastTotal = 0;
    let countLastOnDemand = 0;
    let countLastGcp = 0;
    let countLastGcpApi = 0;

    if (viewedArr.length) {
      const numArr = [];
      viewedArr.forEach((element) => {
        numArr.push(Number(element.count));
      });
      const totalNum = numArr.reduce((x, y) => x + y);
      countLastViewed = ceil(totalNum, 2);
    }
    if (favoritedArr.length) {
      const numArr = [];
      favoritedArr.forEach((element) => {
        numArr.push(Number(element.count));
      });
      const totalNum = numArr.reduce((x, y) => x + y);
      countLastFavorited = ceil(totalNum, 2);
    }
    if (downloadedArr.length) {
      const numArr = [];
      downloadedArr.forEach((element) => {
        numArr.push(Number(element.count));
      });
      const totalNum = numArr.reduce((x, y) => x + y);
      countLastDownloaded = ceil(totalNum, 2);
    }
    if (purchasedArr.length) {
      const numArr = [];
      purchasedArr.forEach((element) => {
        numArr.push(Number(element.count));
      });
      const totalNum = numArr.reduce((x, y) => x + y);
      countLastPurchased = ceil(totalNum, 2);
    }
    if (totalArr.length) {
      const numArr = [];
      totalArr.forEach((element) => {
        numArr.push(Number(element.amount)); // total use amount
      });
      const totalNum = numArr.reduce((x, y) => x + y);
      countLastTotal = ceil(totalNum, 2);
    }
    if (onDemandArr.length) {
      const numArr = [];
      onDemandArr.forEach((element) => {
        numArr.push(Number(element.amount)); // total use amount
      });
      const totalNum = numArr.reduce((x, y) => x + y);
      countLastOnDemand = ceil(totalNum, 2);
    }
    if (gcpSubArr.length) {
      const numArr = [];
      gcpSubArr.forEach((element) => {
        numArr.push(Number(element.amount)); // total use amount
      });
      const totalNum = numArr.reduce((x, y) => x + y);
      countLastGcp = ceil(totalNum, 2);
    }
    if (gcpApiArr.length) {
      const numArr = [];
      gcpApiArr.forEach((element) => {
        numArr.push(Number(element.amount)); // total use amount
      });
      const totalNum = numArr.reduce((x, y) => x + y);
      countLastGcpApi = ceil(totalNum, 2);
    }

    return {
      viewed: countLastViewed,
      favorited: countLastFavorited,
      downloaded: countLastDownloaded,
      purchased: countLastPurchased,
      earnings: {
        total: countLastTotal,
        onDemand: countLastOnDemand,
        gcp: countLastGcp,
        gcp_api: countLastGcpApi,
      },
    };
  },
  countViewed: (state, getters) => {
    if (getters.filterViewed.length) {
      const numArr = [];
      getters.filterViewed.forEach((element) => {
        numArr.push(Number(element.count));
      });
      const totalNum = numArr.reduce((x, y) => x + y);
      return ceil(totalNum, 2);
    }
    return 0;
  },
  countSearched: (state, getters) => {
    if (getters.filterSearched.length) {
      const numArr = [];
      getters.filterSearched.forEach((element) => {
        numArr.push(Number(element.count));
      });
      const totalNum = numArr.reduce((x, y) => x + y);
      return ceil(totalNum, 2);
    }
    return 0;
  },
  countFavorited: (state, getters) => {
    if (getters.filterFavorited.length) {
      const numArr = [];
      getters.filterFavorited.forEach((element) => {
        numArr.push(Number(element.count));
      });
      const totalNum = numArr.reduce((x, y) => x + y);
      return ceil(totalNum, 2);
    }
    return 0;
  },
  countOrderCompleted: (state, getters) => {
    if (getters.filterOrderCompleted.length) {
      const numArr = [];
      getters.filterOrderCompleted.forEach((element) => {
        numArr.push(Number(element.count));
      });
      const totalNum = numArr.reduce((x, y) => x + y);
      return ceil(totalNum, 2);
    }
    return 0;
  },
  countRefundeded: (state, getters) => {
    if (getters.filterRefunded.length) {
      const numArr = [];
      getters.filterRefunded.forEach((element) => {
        numArr.push(Number(element.count));
      });
      const totalNum = numArr.reduce((x, y) => x + y);
      return ceil(totalNum, 2);
    }
    return 0;
  },
  countPurchased: (state, getters) => {
    if (getters.filterPurchased.length) {
      const numArr = [];
      getters.filterPurchased.forEach((element) => {
        numArr.push(Number(element.count));
      });
      const totalNum = numArr.reduce((x, y) => x + y);
      return ceil(totalNum, 2);
    }
    return 0;
  },
  countTotal: (state, getters) => {
    if (getters.filterTotal.length) {
      const numArr = [];
      getters.filterTotal.forEach((element) => {
        numArr.push(Number(element.amount));
      });
      const totalNum = numArr.reduce((x, y) => x + y);
      return ceil(totalNum, 2);
    }
    return 0;
  },
  countOnDemand: (state, getters) => {
    if (getters.filterOnDemand.length) {
      const numArr = [];
      getters.filterOnDemand.forEach((element) => {
        numArr.push(Number(element.amount));
      });
      const totalNum = numArr.reduce((x, y) => x + y);
      return ceil(totalNum, 2);
    }
    return 0;
  },
  countGcp: (state, getters) => {
    if (getters.filterGcp.length) {
      const numArr = [];
      getters.filterGcp.forEach((element) => {
        numArr.push(Number(element.amount));
      });
      const totalNum = numArr.reduce((x, y) => x + y);
      return ceil(totalNum, 2);
    }
    return 0;
  },
  countGcpApi: (state, getters) => {
    if (getters.filterGcpApi.length) {
      const numArr = [];
      getters.filterGcpApi.forEach((element) => {
        numArr.push(Number(element.amount));
      });
      const totalNum = numArr.reduce((x, y) => x + y);
      return ceil(totalNum, 2);
    }
    return 0;
  },
  countImgSubscription: (state, getters) => {
    if (getters.filterImgSubscription.length) {
      const numArr = [];
      getters.filterImgSubscription.forEach((element) => {
        numArr.push(Number(element.amount));
      });
      const totalNum = numArr.reduce((x, y) => x + y);
      return ceil(totalNum, 2);
    }
    return 0;
  },
  // eslint-disable-next-line arrow-body-style
  filterEarnings: (state, getters) => {
    return {
      onDemand: getters.filterOnDemand,
      gcp: getters.filterGcp,
      gcp_api: getters.filterGcpApi,
      img_sub: getters.filterImgSubscription,
      // affiliate: getters.filterAffliate,
      total: getters.filterTotal,
      count: {
        onDemand: getters.countOnDemand,
        gcp: getters.countGcp,
        gcp_api: getters.countGcpApi,
        img_sub: getters.countImgSubscription,
        total: getters.countTotal,
        // affiliate: state.countAffliate,
      },
    };
  },
  // eslint-disable-next-line arrow-body-style
  filterEvents: (state, getters) => {
    return {
      viewed: getters.filterViewed,
      searched: getters.filterSearched,
      favorited: getters.filterFavorited,
      completed: getters.filterOrderCompleted,
      refunded: getters.filterRefunded,
      purchased: getters.filterPurchased,
      count: {
        viewed: getters.countViewed,
        searched: getters.countSearched,
        favorited: getters.countFavorited,
        completed: getters.countOrderCompleted,
        refunded: getters.countRefundeded,
        purchased: getters.countPurchased,
      },
    };
  },
  //
  query(state, getters) {
    if (getters.periodStart && getters.periodEnd) {
      return `period_start=${getters.periodStart}&period_end=${getters.periodEnd}&program=${state.reportType}`;
    }
    return null;
  },
};

const actions = {
  getGcpProgram({ commit }) {
    programsApi.getProgram('gcp').then((response) => {
      commit('setGcpProgram', response.data.data);
    });
  },
  getListEarnings({ state, commit, getters }) {
    commit('setEarningsLoading', true);
    const cancelToken = refreshCancelToken(state, 'getListEarnings');
    const axiosConfig = {
      cancelToken: cancelToken.token,
    };
    const params = {
      period_start: getters.periodStart,
      period_end: getters.periodEnd,
      interval: getters.interval,
      program: state.reportType,
    };

    if (state.mock === true) {
      params.mock = state.mock;
      // commit('setSalesData', { type: 'earnings', data: salesEarningData.data });
      salesApi.listSalesEarningsMock(params).then((response) => {
        commit('setSalesData', { type: 'earnings', data: response.data.data });
      });
      return false;
    }

    salesApi.listSalesEarnings(params, axiosConfig).then((response) => {
      // this.earnings = response.data.data;
      // response.data.data = salesEarningsMockData;
      commit('setSalesData', { type: 'earnings', data: response.data.data });
    })
      .finally(() => {
        commit('setEarningsLoading', false);
      });
  },
  getListEvents({ state, commit, getters }) {
    commit('setEventsLoading', true);
    const params = {
      period_start: getters.periodStart,
      period_end: getters.periodEnd,
      interval: getters.interval,
      program: state.reportType,
    };

    if (state.mock === true) {
      params.mock = state.mock;
      // commit('setSalesData', { type: 'events', data: salesEventMockData.data });
      salesApi.listSalesEventsMock(params).then((response) => {
        commit('setSalesData', { type: 'events', data: response.data.data });
      });
      return false;
    }

    salesApi.listSalesEvents(params).then((response) => {
      // this.events = response.data.data;
      // response.data.data = salesEventsMockData;
      commit('setSalesData', { type: 'events', data: _.get(response, 'data.data', []) });
    })
      .finally(() => {
        commit('setEventsLoading', false);
      });
  },
  // setPeriodStart({ commit }, value) {
  //   commit('setPeriodStart', value);
  // },
  // setPeriodEnd({ commit }, value) {
  //   commit('setPeriodEnd', value);
  // },
  // eslint-disable-next-line no-unused-vars
  resetAllData({ commit }) {
    commit('resetAllData');
  },
  LIST_ON_DEMAND_DOWNLOADS({ commit, getters }, payload) {
    const cancelToken = refreshCancelToken(state, 'listOnDemandDownlaods');
    const axiosConfig = {
      cancelToken: cancelToken.token,
    };
    const params = {
      period_start: getters.periodStart,
      period_end: getters.periodEnd,
      ...payload,
    };
    return salesApi.listOnDemandDownloads(params, axiosConfig)
      .then((response) => {
        commit('setRecentDownloads', response.data.data);
      });
  },
  LIST_SALES_EVENTS({ commit, getters }, payload) {
    const cancelToken = refreshCancelToken(state, 'listSalesEvents');
    const axiosConfig = {
      cancelToken: cancelToken.token,
    };
    const params = {
      period_start: getters.periodStart,
      period_end: getters.periodEnd,
      ...payload,
    };
    return salesApi.listSalesEvents(params, axiosConfig)
      .then((response) => {
        commit('setSalesEvents', response.data.data);
      });
  },
  LIST_SALES_ALL_KEYWORDS({ commit, getters }, payload) {
    const cancelToken = refreshCancelToken(state, 'listSalesAllKeywords');
    const axiosConfig = {
      cancelToken: cancelToken.token,
    };
    const params = {
      period_start: getters.periodStart,
      period_end: getters.periodEnd,
      ...payload,
    };
    return salesApi.listSalesAllKeywords(params, axiosConfig)
      .then((response) => {
        commit('setSalesKeywords', _.get(response, 'data.data', []));
      });
  },
  LIST_SALES_EVENTS_FUNNEL({ commit, getters }, payload) {
    const cancelToken = refreshCancelToken(state, 'listSalesEventsFunnel');
    const axiosConfig = {
      cancelToken: cancelToken.token,
    };
    const params = {
      period_start: getters.periodStart,
      period_end: getters.periodEnd,
      ...payload,
    };
    return salesApi.listSalesEvents(params, axiosConfig)
      .then((response) => {
        commit('setSalesEventsFunnel', response.data.data);
      });
  },
  LIST_SALES_PRODUCTS({ commit, getters }, payload) {
    const cancelToken = refreshCancelToken(state, 'listSalesProducts');
    const axiosConfig = {
      cancelToken: cancelToken.token,
    };
    const params = {
      period_start: getters.periodStart,
      period_end: getters.periodEnd,
      ...payload,
    };
    return salesApi.listSalesProducts(params, axiosConfig)
      .then((response) => {
        commit('setSalesProducts', response.data.data);
      });
  },
};

const mutations = {
  resetAllData(state) {
    state.events = [];
    state.earnings = [];
    state.eventsLastYear = [];
    state.earningsLastYear = [];
  },
  setSalesData(state, payload) {
    if (payload.type === 'earnings') {
      state.earnings = payload.data;
    }
    if (payload.type === 'events') {
      state.events = payload.data;
    }
  },
  setEarningsLoading(state, status) {
    state.earningsLoading = status;
  },
  setEventsLoading(state, status) {
    state.eventsLoading = status;
  },
  setReportType(state, value) {
    state.reportType = value;
  },
  setPeriod(state, payload) {
    console.log('set period: ', payload);
    if (!payload.type) {
      console.log('setPeriod need type!!');
      return;
    }
    if (payload.type === 'start') {
      state.periodStart = payload.value;
      const date = payload.value.split('-');
      state.startYear = date[0];
      state.startMonth = Number(date[1]) - 1;
    }
    if (payload.type === 'end') {
      state.periodEnd = payload.value;
      const date = payload.value.split('-');
      state.endYear = date[0];
      state.endMonth = Number(date[1]) - 1;
    }
  },
  setPeriodYearMonth(state, payload) {
    console.log('set period: ', payload);
    if (!payload.type) {
      console.log('setPeriod need type!!');
      return;
    }
    if (payload.type === 'start') {
      if (payload.ym === 'year') {
        state.startYear = payload.value;
      }
      if (payload.ym === 'month') {
        state.startMonth = payload.value;
      }
    }
    if (payload.type === 'end') {
      if (payload.ym === 'year') {
        state.endYear = payload.value;
      }
      if (payload.ym === 'month') {
        state.endMonth = payload.value;
      }
    }
  },
  setLastPeriod(state, payload) {
    if (!payload.type) {
      console.log('setLastPeriod need type!!');
      return;
    }
    if (payload.type === 'start') {
      state.periodStartLastYear = payload.value;
    }
    if (payload.type === 'end') {
      state.periodEndLastYear = payload.value;
    }
  },
  // setPeriodYearMonth(state, payload) {
  //   if (!payload.type) {
  //     console.log('setPeriod need type!!');
  //     return;
  //   }
  //   if (payload.type === 'start') {
  //     state.periodStart = payload.value;
  //   }
  //   if (payload.type === 'end') {
  //     state.periodEnd = payload.value;
  //   }
  // },
  // setPeriodStart(state, value) {
  //   state.periodStart = value;
  // },
  // setPeriodEnd(state, value) {
  //   state.periodStart = value;
  // },
  setElementsStats(state, data) {
    state.elementsStats = data;
  },
  setGcpProgram(state, data) {
    state.gcpProgram = data;
  },
  toggleMock(state, payload) {
    state.mock = payload;
  },
  //
  setStartMonth(state, startMonth) {
    console.log('========== setStartMonth: ', startMonth);
    state.startMonth = startMonth;
  },
  setStartYear(state, startYear) {
    state.startYear = startYear;
  },
  setEndMonth(state, endMonth) {
    console.log('========== setEndMonth: ', endMonth);
    state.endMonth = endMonth;
  },
  setEndYear(state, endYear) {
    state.endYear = endYear;
  },
  //
  setRecentDownloads(state, downloads) {
    state.recentDownloads = downloads;
  },
  setSalesEvents(state, events) {
    state.salesEvents = events;
  },
  setSalesKeywords(state, salesKeywords) {
    state.salesKeywords = salesKeywords;
  },
  setSalesEventsFunnel(state, funnelData) {
    state.funnelData = funnelData;
  },
  setSalesProducts(state, salesProducts) {
    state.salesProducts = salesProducts;
  },
  //
  setInterval(state, interval) {
    state.interval = interval;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
